import { useLocalStorageState } from "@istari-frontend/shared";

export type ChatDockPosition = "right" | "bottom";

const STORAGE_KEY = "istari-ai-chat-dock-position";

export function useChatDockPosition(): {
  dock: ChatDockPosition;
  setDock: (position: ChatDockPosition) => void;
} {
  const [dock, setDock] = useLocalStorageState<ChatDockPosition>(STORAGE_KEY, "right");
  return { dock, setDock };
}
